
import { defineComponent, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { orders } from '@/composables/orders'

export default defineComponent(
{
    name: 'Header',
    setup()
    {
        // Load router:
        const router = useRouter()
        // Load vuex:
        const store = useStore()

        // Computed state params:
        const isAuthenticated = computed(() =>
        {
            return store.getters['auth/isAuthenticated']
        })
        // Get user data:
        const authenticatedUser = computed(() =>
        {
            return store.getters['auth/getUser']
        })
        const getBasketCount = computed(() =>
        {
            return store.getters['basket/getBasketCount']
        })

        // Prepare for orders:
        const {
            data
        } = orders(10000)

        const getOrdersCount = computed(() =>
        {
            if(data.entries === undefined)
            {
                return 0
            }
            return data.entries.length
        })

        // Set menu items:
        const menuItems = computed(() =>
        {
            // Start items array:
            const items = []
            // Add items based on authenticaion:
            if(getBasketCount.value > 0)
            {
                items.push(
                {
                    name: 'Basket',
                    text: 'My Basket (' + getBasketCount.value + ')'
                })
            }

            // Add items based on authenticaion:
            if(isAuthenticated.value)
            {
                if(getOrdersCount.value > 0)
                {
                    items.push(
                    {
                        name: 'Orders',
                        text: 'My Orders (' + getOrdersCount.value + ')'
                    })
                }
                items.push(
                {
                    name: 'Account',
                    text: 'My Account'
                })
            }
            else
            {
                items.push({
                    name: 'Register',
                    text: 'Create an account'
                })
                items.push({
                    name: 'Login',
                    text: 'Sign in'
                })
            }
            // Add remaining items:
            items.push(
            {
                name: 'Help',
                text: 'Help'
            })
            items.push(
            {
                name: 'Release notes',
                text: 'Release notes'
            })

            return items
        })

        // Set visible:
        const isMenuVisible = ref(false)
        // Compute classes for menu:
        const menuClassList = computed(() =>
        {
            return {
                'govuk-header__navigation': true,
                'govuk-header__navigation--open': isMenuVisible.value
            }
        })

        // Logout function:
        const handleLogout = function()
        {
            store.commit('auth/logout')
            router.push({ name: 'Home' })
        }

        // Return data:
        return {
            isAuthenticated,
            getBasketCount,
            menuItems,
            isMenuVisible,
            menuClassList,
            handleLogout
        }
    }
})
